import React, { Fragment } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import clsx from "classnames";

const BRoundButton = ({ direction, variant, title, shape, icon, onClick, className, ...props }) => {
    const baseClass = clsx("btn-icon", `btn-${shape}`, className);
    return (
        <Fragment>
            <OverlayTrigger
                placement={direction}
                overlay={<Tooltip id={`tooltip-create-edit`}>{title}</Tooltip>}
            >
                <Button variant={variant} className={baseClass} onClick={onClick} {...props}>
                    <i className={`feather ${icon}`} />
                </Button>
            </OverlayTrigger>
        </Fragment>
    );
};

BRoundButton.defaultProps = {
    direction: "right",
    title: "",
    variant: "success",
    icon: "icon-alert-triangle",
    shape: "rounded" // square
};

export default BRoundButton;
